

















import { Component } from 'vue-property-decorator';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import {
    DeleteLocationRequest,
    Location,
    PostLocationRequest,
    PutLocationRequest,
} from '@/model/Location';
import { EventResponse } from '@/model/Event';
import ToastVariant from '@/model/enums/toast/toast-variant';
import { mixins } from 'vue-class-component';
import ToastMixin from '@/mixins/ToastMixin';
import { ApiError } from '@/model/ApiError';
import LocationTopicResoposibleTable from '@/components/master-data/LocationTopicResponsibleTable.vue';

@Component({
    components: {
        LocationTopicResoposibleTable,
    },
    methods: {
        ...mapActions({
            fetchEventById: 'eventStorage/fetchEventById',
            fetchLocations: 'locationsStorage/fetchLocations',
            deleteLocation: 'locationsStorage/deleteLocation',
            putLocation: 'locationsStorage/putLocation',
            postLocation: 'locationsStorage/postLocation',
        }),
        ...mapMutations({
            setLocations: 'locationsStorage/setLocations',
        }),
    },
    computed: {
        ...mapGetters({
            getLocations: 'locationsStorage/getLocations',
            getError: 'locationsStorage/getError',
        }),
    },
})
export default class Locations extends mixins(ToastMixin) {
    fetchLocations!: (eventId: number) => Promise<void | Location[]>;

    deleteLocation!: (
        deleteLocationRequest: DeleteLocationRequest,
    ) => Promise<void>;

    putLocation!: (putLocationRequest: PutLocationRequest) => Promise<void>;

    postLocation!: (postLocationRequest: PostLocationRequest) => Promise<void>;

    fetchEventById!: (id: number) => Promise<void | EventResponse>;

    setLocations!: (invitedUsers: Location[] | null) => void;

    getLocations!: Location[] | null;

    getError!: ApiError | null;

    eventId: number = +this.$route.params.id;

    loading = false;

    mounted(): void {
        this.loading = true;
        this.$store.commit('locationsStorage/setError', null);
        Promise.all([
            this.fetchLocations(this.eventId),
            this.fetchEventById(this.eventId).catch(() => {
                this.$router.push(`/event/${this.eventId}`);
            }),
        ])
            .catch((error) => {
                this.$store.commit('locationsStorage/setError', error);
            })
            .finally(() => {
                this.loading = false;
            });
    }

    destroyed(): void {
        this.setLocations(new Array<Location>());
    }

    onRemove(location: Location): void {
        this.deleteLocation({
            eventId: this.eventId,
            locationId: location.id,
        })
            .then(() => {
                this.fetchLocations(this.eventId);
                this.showToast(
                    this.$t('location.toast.delete.succes').toString(),
                    this.$t('location.toast.delete.title').toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .catch(() => {
                if (this.getError?.key) {
                    if (this.getError?.key === 'has-event-item.location') {
                        this.showToast(
                            this.$t(`${this.getError.key}`).toString(),
                            this.$t('location.toast.delete.title').toString(),
                            ToastVariant.DANGER,
                        );
                    }
                }
            });
    }

    onAdd(location: Location | null): void {
        if (location === null) {
            return;
        }
        this.postLocation({
            location,
            eventId: this.eventId,
        }).then(() => {
            this.fetchLocations(this.eventId);
            this.showToast(
                this.$t('location.toast.add.succes').toString(),
                this.$t('location.toast.add.title').toString(),
                ToastVariant.SUCCESS,
            );
        });
    }

    onSaveEdit(location: Location): void {
        this.putLocation({
            location,
            eventId: this.eventId,
        })
            .then(() => {
                this.fetchLocations(this.eventId);
                this.showToast(
                    this.$t('location.toast.edit.succes').toString(),
                    this.$t('location.toast.edit.title').toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .catch(() => {
                if (this.getError?.key) {
                    if (this.getError?.key === 'validation.field-invalid') {
                        this.showToast(
                            this.$t(
                                `${this.getError?.validationMessages?.name}`,
                            ).toString(),
                            this.$t('location.toast.edit.title').toString(),
                            ToastVariant.DANGER,
                        );
                    } else if (
                        this.getError?.key === 'already-exist.location-in-event'
                    ) {
                        this.showToast(
                            this.$t(`${this.getError.key}`).toString(),
                            this.$t('location.toast.edit.title').toString(),
                            ToastVariant.DANGER,
                        );
                    }
                }
            });
    }
}
